/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

const DispensingHeader = () => {
	const { t } = useTranslation();
	return (
		<div className="px-10 py-3 border-b border-slate-100 flex items-center justify-between bg-[#0F172A] text-white">
			<div className="flex items-center gap-4">
				<h2 className="text-xs font-black uppercase tracking-[0.3em]">
					{t("mediaBatchInit.dispenseEntry.dispensingDetails")}
				</h2>
				<div className="flex items-center gap-2 bg-orange-500 text-white px-2.5 py-1 rounded text-[8px] font-black uppercase tracking-widest shadow-lg shadow-orange-500/20">
					<span className="material-symbols-outlined text-[10px] font-black">
						star
					</span>
					{t("mediaBatchInit.dispenseEntry.fefoSuggested")}
				</div>
			</div>
			<button className="flex items-center gap-1 px-5 py-1.5 border border-slate-700/50 rounded-xl text-[9px] font-black uppercase tracking-widest hover:bg-slate-800 transition-all">
				<span className="material-symbols-outlined text-sm font-black">
					open_in_new
				</span>
				{t("mediaBatchInit.dispenseEntry.viewContainerLifeCycle")}
			</button>
		</div>
	);
};
export default DispensingHeader;
